const moment = require('moment')
const _ = require('lodash')
const filters = require('@/../functions/shared/filters')
const printChart = require('@/../functions/print/printChart')

exports.dataToTable = async function (forms, data, prefix, printConfig) {
  let baseTable = formTable(forms)

  let result = []
  let resultIndex = {}
  let promises = {}

  for (let keyBase in data) {
    // Valor
    let percentil = null
    let value = data[keyBase]
    let author = null
    if (!value) continue

    // tratamento do valor
    if (typeof value === 'object') {
      if (value.percentil) percentil = value.percentil
      if (value.result) value = value.result
      if (value.author) author = value.author
    }

    // Ajuste a chave
    let key = prefix ? prefix + keyBase : keyBase

    // Verifica campos a serem impressos
    const keyTemplate = key.replace(/_\d/, '$')

    // Pega a config do field
    let base = baseTable[keyTemplate]
    if (!base || base.comp.hidden) continue
    const m = /_(\d)/.exec(key)
    const item = m ? m[1] : 1

    // Ajuste o percentil do campo de referencia
    if (base.comp.type === 'chartline') {
      if (base.comp.reference) {
        let refKey = base.comp.reference.replace('$', `_${item}`)
        if (resultIndex[refKey]) {
          resultIndex[refKey]['percentil'] = percentil
        } else {
          resultIndex[refKey] = {percentil}
        }
        continue
      }
    }

    if (printConfig && printConfig.length > 0 && !printConfig.includes(keyTemplate)) continue

    // Ajusta conforme o filtro
    if (base.comp.filter && filters[base.comp.filter]) {
      value = filters[base.comp.filter](value)
    }
    // Sufixo
    if (base.comp.suffix && typeof value !== 'object') {
      value += ` ${base.comp.suffix}`
    }

    // Ajuste do campo select
    if (base.comp.type === 'select') {
      if (!_.isEmpty(base.comp.items)) {
        if (base.comp.multiple) {
          value = value.join(', ')
        } else if (typeof base.comp.items[0] === 'object') {
          let items = base.comp.items.filter(item => _.isEqual(item.value, value))
          if (!_.isEmpty(items)) {
            value = items[0].text
          }
        }
      }
    }

    // Ajuste do campo datepicker
    if (base.comp.type === 'datepicker') {
      if (value && typeof value === 'object' && ['Timestamp', 't'].indexOf(value.constructor.name) > -1) {
        if (value.toDate) {
          value = value.toDate()
        }
      }
      value = moment(value).format('DD/MM/YYYY')
    }

    // Ajuste do campo table row
    if (base.comp.type === 'row') {
      if (value === 'normal') {
        value = 'Sem alterações evidentes.'
      }
      if (data[keyBase + '.obs']) {
        value += ` - ${data[keyBase + '.obs']}`
      }
    }

    // Verifica se tem valor
    if (['undefined', 'null', 'NaN', ''].includes(String(value))) continue

    // Ajuste do campo table row || GChart
    if (printConfig && (base.comp.type === 'evolutionchart' || base.comp.type === 'gChart')) {
      console.log('printTableS')
      promises[key] = printChart.render(base.comp, value, 'png', author)
    }

    // adciona o percentil no value
    if (base.comp.showPercentil) {
      value = `${value} (percentil ${Math.round(percentil * 100)})`
    }

    let row = {
      key: key,
      item: item,
      order: base.order,
      form: base.form.label || '',
      panel: base.panel.label || '',
      tab: base.tab.label || '',
      itemLabel: base.tab.label ? base.tab.label.substring(0, base.tab.label.length - 1) + ' ' + item : '',
      comp: base.comp.label,
      type: base.comp.type,
      value,
      percentil
    }

    // Junto as informações, caso os fields estejam fora de ordem.
    _.merge(row, resultIndex[key])

    resultIndex[key] = row
    result.push(row)
  }

  if (promises) {
    let promiseValues = await Promise.all(Object.values(promises))
    let promiseKeys = Object.keys(promises)
    for (let i in promiseValues) {
      resultIndex[promiseKeys[i]].value = promiseValues[i].data
    }
  }

  return _.orderBy(result, ['order', 'item'])
}

function formTable (formJson) {
  let table = flatForms(formJson)
  let keysTable = table.reduce((acc, item, i) => {
    acc[item.key] = {order: i, ...item}
    return acc
  }, {})

  return keysTable
}

function flatForms (forms) {
  let table = []
  for (let f in forms.components) {
    let form = forms.components[f]
    for (let p in form.components) {
      let panel = form.components[p]
      for (let c in panel.components) {
        let tab = {label: null}
        let comp = panel.components[c]
        let preKey = (form.key ? form.key + '.' : '') + panel.key
        if (comp.components) {
          tab = comp
          let tabItem = tab.components[0]
          for (let t in tabItem.components) {
            comp = tabItem.components[t]
            const key = preKey + '.' + tab.key + '.' + tabItem.key + '.' + (comp.key || 'comp' + t)
            if (comp.type === 'table') {
              for (let r in comp.rows) {
                let row = comp.rows[r]
                const rowKey = key + '.' + row.key
                table.push({key: rowKey, form, panel, tab, comp: {type: 'row', ...row}})
              }
            } else {
              table.push({key, form, panel, tab, comp})
            }
          }
        } else {
          const key = preKey + '.' + (comp.key || 'comp' + c)
          table.push({key, form, panel, tab, comp})
        }
      }
    }
  }
  return table
}



// WEBPACK FOOTER //
// ./src/utils/printTables.js